import React, { useContext, createContext, useState, useEffect, useCallback, useMemo } from "react"
import moment from "moment";

import avatar from "../../assets/img/avatar.webp"

import { useSelector } from 'react-redux';

const Profile = createContext({});

export const ProfileProvider = (props) => {
    const { companyDetails, packages } = useSelector((state) => state.global);

    const [showUpgrade, setShowUpgrade] = useState();

    /*------------------------Account Controls---------------------------*/
    const defaultAvatar = localStorage.getItem("image") == "null" ? avatar : localStorage.getItem("image");

    const [previewImg, setPreviewImg] = useState({
        user: defaultAvatar,
        company: companyDetails?.company?.logo != null ? companyDetails?.company?.logo : avatar
    });
    const [newImage, setNewImage] = useState({
        user: defaultAvatar,
        company: companyDetails?.company?.logo
    });

    /*------------------------Subscription Info---------------------------*/
    const [mediaUsageInfo, setMediaUsageInfo] = useState({
        mediaUsage: 0,
        allowedTotal: 0,
    });

    /*----------------------------Payment Control-------------------*/
    // Billing data
    const [numberOfScreens, setNumberOfScreens] = useState(1);
    const [selectedPackage, setSelectedPackage] = useState({});
    const [isUpgrade, setIsUpgrade] = useState();
    const [selectedPricing, setSelectedPricing] = useState({});

    const [action, setAction] = useState("");

    const [paymentData, setPaymentData] = useState({
        subtotal: 0,
        total: 0,
        tax: 0,
        remainingCredit: 0
    });

    useEffect(() => {
        setNumberOfScreens(companyDetails?.company?.allowed_device_number)
        // Handle Media Usage
        let _packageMediaStorage = companyDetails?.package?.features["media_storage_capacity"];
        let _companyMediaStorage = companyDetails?.company?.allowed_media_usage / Math.pow(1024, 3);

        setMediaUsageInfo({
            mediaUsage: companyDetails?.media_usage,
            allowedTotal: _packageMediaStorage > 1000 ? "unlimited" : Math.max(_packageMediaStorage, _companyMediaStorage),
        });

        setSelectedPackage(companyDetails?.package)
    }, [companyDetails]);

    useEffect(() => {
        setSelectedPricing(prev => selectedPackage?.prices?.find(pricing => pricing.period == prev?.period))
    }, [selectedPackage]);


    // useEffect(() => {
    //     var _singleScreenPrice = selectedPricing?.price;
    //     var _period = selectedPricing?.period
    //     var _subtotal = selectedPricing?.price * numberOfScreens

    //     if (action == "switchToYearly")
    //         setNumberOfScreens(companyDetails.company?.allowed_device_number)

    //     if (action == "addScreens") {
    //         const start = moment(companyDetails.subscription.start_date).startOf('day');
    //         const end = moment(companyDetails.subscription.end_date).startOf('day');
    //         const today = moment().startOf('day');

    //         let totalSubscriptionDays = end.diff(start, 'days');
    //         var remindingDays = end.diff(today, 'days');
    //         // let totalSubscriptionDays = moment(companyDetails?.subscription?.end_date).diff(moment(companyDetails?.subscription?.start_date), 'days');
    //         // var remindingDays = (moment(companyDetails?.subscription?.end_date)).diff(moment(), 'days') + 1;

    //         _period = remindingDays + " day" + (remindingDays > 1 ? "s" : "")
    //         _subtotal = (selectedPricing?.price / totalSubscriptionDays) * remindingDays * numberOfScreens;
    //         _singleScreenPrice = (selectedPricing?.price / totalSubscriptionDays) * remindingDays
    //     }

    //     let _tax = _subtotal * (selectedPackage?.tax / 100);

    //     setPaymentData({
    //         singleScreenPrice: _singleScreenPrice?.toFixed(2),
    //         subtotal: _subtotal.toFixed(2),
    //         period: _period,
    //         total: (_subtotal + _tax).toFixed(2),
    //         tax: _tax.toFixed(2),
    //     })

    // }, [selectedPricing, numberOfScreens, action]);

    useEffect(() => {
        const toMoney = (n) => Number(n || 0);

        // --- inputs we already have ---
        const newPricePerScreen = toMoney(selectedPricing?.price); // target plan price per screen for its period
        let _singleScreenPrice = newPricePerScreen;
        let _period = selectedPricing?.period;
        let _subtotal = newPricePerScreen * (numberOfScreens || 0);
        let originalSubtotal = newPricePerScreen * (numberOfScreens || 0);

        let isFree = companyDetails?.package?.prices[0]?.price === 0;



        // If switching to yearly, keep UI consistent with your earlier behavior
        if (action === "switchToYearly") {
            setNumberOfScreens(companyDetails?.company?.allowed_device_number || 0);
        }

        // current cycle boundaries
        const start = moment.utc(companyDetails?.subscription?.start_date).startOf("day");
        const end = moment.utc(companyDetails?.subscription?.end_date).startOf("day");
        const today = moment.utc().startOf("day");

        const totalSubscriptionDays = Math.max(1, end.diff(start, "days")); // prevent divide-by-zero
        const elapsedDays = Math.max(0, today.diff(start, "days"));
        const remainingDays = Math.max(0, end.diff(today, "days"));

        //  Add Screens (your existing logic, left intact) ---
        if (action === "addScreens") {
            _period = `${remainingDays} day${remainingDays > 1 ? "s" : ""}`;
            _singleScreenPrice = (newPricePerScreen / totalSubscriptionDays) * remainingDays;
            _subtotal = _singleScreenPrice * (numberOfScreens || 0);
        }
        let remainingCredit = 0
        // Upgrade plan/package (prorated difference for remainder of cycle) ---
        if (!!isUpgrade && action !== "addScreens" && !isFree) {
            const currentPeriod =
                companyDetails?.subscription?.period ||
                companyDetails?.subscription?.pricing_period ||
                "ONE_MONTH";

            const oldPricePerScreen =
                toMoney(companyDetails?.subscription_pricing?.price) ||
                toMoney(companyDetails?.package?.prices[0]?.price) ||
                toMoney(
                    (companyDetails?.subscription?.package?.prices || [])
                        .find((p) => p?.period === currentPeriod)?.price
                ) ||
                0;

            let totalOldPackage = numberOfScreens * oldPricePerScreen
            let oldDailyPrice = totalOldPackage / totalSubscriptionDays
            let totalUsedFromOldPackage = oldDailyPrice * elapsedDays
            let remainCreditFromOldPackage = totalOldPackage - totalUsedFromOldPackage

            let totalNewPackage = numberOfScreens * newPricePerScreen;
            let newDailyPrice = totalNewPackage / totalSubscriptionDays;
            let unuseableDaysOnTheNewPackage = newDailyPrice * elapsedDays;
            let netTotalNewPackage = totalNewPackage - unuseableDaysOnTheNewPackage - remainCreditFromOldPackage;

            remainingCredit = remainCreditFromOldPackage;



            // _subtotal = proratedPerScreen * (numberOfScreens || 0);
            _subtotal = totalNewPackage - unuseableDaysOnTheNewPackage;

            _period = `${remainingDays} day${remainingDays > 1 ? "s" : ""} (prorated)`;
        }

        // --- Tax & totals (shared) ---
        const _tax = _subtotal * (toMoney(selectedPackage?.tax) / 100);

        setPaymentData({
            singleScreenPrice: _singleScreenPrice.toFixed(2),
            subtotal: _subtotal.toFixed(2),
            originalSubtotal: originalSubtotal,
            period: _period,
            remainingCredit: remainingCredit.toFixed(2),
            total: (_subtotal + _tax - remainingCredit).toFixed(2),
            tax: _tax.toFixed(2),
        });
    }, [selectedPricing, numberOfScreens, action, isUpgrade, selectedPackage]);


    const onScreenChange = useCallback(
        (action, value = 1) => {
            switch (action) {
                case 'increment':
                    setNumberOfScreens((prevCount) => prevCount + 1);
                    break;
                case 'decrement':
                    setNumberOfScreens((prevCount) => prevCount - 1);
                    break;
                case 'onChange':
                    setNumberOfScreens(value);
                    break;
                default:
                    setNumberOfScreens(1);
                    break;
            }
        },
        [setNumberOfScreens]
    );

    return (
        <Profile.Provider value={{
            // account
            previewImg, setPreviewImg,
            newImage, setNewImage,
            // subscription
            mediaUsageInfo, setMediaUsageInfo,

            // payment
            selectedPackage, setSelectedPackage,
            isUpgrade, setIsUpgrade,
            // remainingCredit,setRemainingCredit,
            selectedPricing, setSelectedPricing,
            numberOfScreens, onScreenChange,
            action, setAction,
            paymentData,
            showUpgrade, setShowUpgrade

        }}>
            {props.children}

        </Profile.Provider>
    )

}

export const useProfileContext = () => {
    return useContext(Profile)
}
